import CloseIcon from "@mui/icons-material/Close";
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography } from "@mui/material";
import { IAgreementInstallment } from "../../../../shared/services/api/sinister/SinisterAgreementService";
import { formatDateFnsRemoveTimezone } from "../../../../shared/utils/format-date";
import { formatScaleValueBR } from "../../../../shared/utils/formatScaleValue";

interface Props {
	open: boolean;
	installment: IAgreementInstallment;
	onClose: () => void;
}

export const ModalAgencyTransferDetails = ({ open, installment, onClose }: Props) => {
	const registration = installment.agencyTransferRegistration;

	return (
		<Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}>
			<DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
				<Typography variant="h6" color="primary" sx={{ fontWeight: 400 }}>
					Detalhes do Repasse
				</Typography>
				<IconButton onClick={onClose} size="small">
					<CloseIcon fontSize="small" />
				</IconButton>
			</DialogTitle>

			<DialogContent dividers>
				{registration ? (
					<Stack spacing={1.5}>
						<Box display="flex" justifyContent="space-between">
							<Typography variant="body2" color="text.secondary">
								Parcela
							</Typography>
							<Typography variant="body2" fontWeight={500}>
								{installment.number}
							</Typography>
						</Box>
						<Box display="flex" justifyContent="space-between">
							<Typography variant="body2" color="text.secondary">
								Valor repassado
							</Typography>
							<Typography variant="body2" fontWeight={500}>
								{formatScaleValueBR(String(registration.value))}
							</Typography>
						</Box>
						<Box display="flex" justifyContent="space-between">
							<Typography variant="body2" color="text.secondary">
								Data do repasse
							</Typography>
							<Typography variant="body2" fontWeight={500}>
								{formatDateFnsRemoveTimezone(registration.transferDate) || "-"}
							</Typography>
						</Box>
						<Box display="flex" justifyContent="space-between">
							<Typography variant="body2" color="text.secondary">
								Registrado por
							</Typography>
							<Typography variant="body2" fontWeight={500}>
								{registration.registeredByUserName}
							</Typography>
						</Box>
						<Box display="flex" justifyContent="space-between">
							<Typography variant="body2" color="text.secondary">
								Registrado em
							</Typography>
							<Typography variant="body2" fontWeight={500}>
								{formatDateFnsRemoveTimezone(registration.createdAt) || "-"}
							</Typography>
						</Box>
						{registration.note && (
							<Box>
								<Typography variant="body2" color="text.secondary" mb={0.5}>
									Observação
								</Typography>
								<Typography variant="body2">{registration.note}</Typography>
							</Box>
						)}
					</Stack>
				) : (
					<Typography variant="body2" color="text.secondary">
						Nenhum repasse registrado para esta parcela.
					</Typography>
				)}
			</DialogContent>
		</Dialog>
	);
};
